import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { take } from 'rxjs/operators';
import { UserModel } from 'src/app/core/models/user.model';
import { Router } from '@angular/router';
import { NbAuthResult } from '@nebular/auth';
import { BaseComponent } from 'src/app/pages/area-privada/components/base/base.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'dum-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent extends BaseComponent implements OnInit, OnDestroy {
  user: UserModel = new UserModel();
  alive: boolean;
  imgCencyl: string;
  imgInterreg: string;
  imgDuminval: string;
  constructor(
    private userService: UserService,
    private router: Router) {
    super();
    this.imgCencyl = environment.logo_cencyl;
    this.imgInterreg = environment.logo_interreg;
    this.imgDuminval = environment.logo_duminval;
  }
  ngOnDestroy(): void {
    this.alive = false;
  }

  ngOnInit(): void {
  }

  login() {
    this.userService.login(this.user.email, this.user.password)
      .pipe(take(1))
      .subscribe((result: NbAuthResult) => {
        if (result.isSuccess()) {
          this.router.navigate(['area-privada']);
        } else {
          this.dumToast.add({ severity: 'error', summary: 'Inicio de sesion', detail: 'Usuario/Contraseña incorrectos' });
        }
      });
  }

  registrarPublico() {
    this.router.navigate(['registro-usuario-publico']);
  }

  restartPasword() {
    if (!this.user.email) {
      this.dumToast.add({ severity: 'error', summary: 'Restaurar password', detail: 'Por favor introduzca su email para la recuperación de la contraseña' });
    } else {
      this.userService.restorePassword(this.user.email)
      .pipe(take(1))
      .subscribe((result) => {
        this.dumToast.add({ severity: 'success', summary: 'Restaurar password', detail: result.message });
      });
    }

  }

}
